<template>
	<div>
		<div class="" style="position: relative;width:100%;height: 100%;">
			<!--  -->
			<div class="back" v-if="mapLevae == 2" @click="mapLevae = 1 ,getMapData('china')">返回上一级</div>
			<div id="myEcharts4" style="width:100%;height:100%;"></div>
			<div class="tuli">
				<div class="flex alit" @click="showType('供应商')">
					<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hotpot/brain/%E5%9B%BE%E4%BE%8B/%E4%BE%9B%E5%BA%94%E5%95%86.png"
						style="width: 33px;height: 36px;margin-right: 6px;" alt="" />
					<div class="tuli-title">供应商</div>
				</div>
				<div class="flex alit">
					<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hotpot/brain/%E5%9B%BE%E4%BE%8B/%E9%87%87%E8%B4%AD%E5%95%86.png"
						style="width: 33px;height: 36px;margin-right: 6px;" alt="" />
					<div class="tuli-title">采购商</div>
				</div>
				<div class="flex alit">
					<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hotpot/brain/%E5%9B%BE%E4%BE%8B/%E7%B2%BE%E6%B7%B1%E5%8A%A0%E5%B7%A5.png"
						style="width: 33px;height: 36px;margin-right: 6px;" alt="" />
					<div class="tuli-title">精深加工厂</div>
				</div>
				<div class="flex alit">
					<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hotpot/brain/%E5%9B%BE%E4%BE%8B/%E5%89%8D%E7%BD%AE%E4%BB%93.png"
						style="width: 33px;height: 36px;margin-right: 6px;" alt="" />
					<div class="tuli-title">前置仓</div>
				</div>
				<div class="flex alit">
					<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hotpot/brain/%E5%9B%BE%E4%BE%8B/%E8%94%AC%E8%8F%9C%E5%9F%BA%E5%9C%B0.png"
						style="width: 33px;height: 36px;margin-right: 6px;" alt="" />
					<div class="tuli-title">蔬菜基地</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import * as echarts from 'echarts'
	import 'echarts-gl'
		export default {
		props: {
			scanal: {
				type: Number
			},
			businessPoints: {
				type: Array,
				default: () => []
			},
			selectedPointId: {
				type: String,
				default: ''
			}
		},
		watch: {
			businessPoints: {
				deep: true,
				handler() {
					this.updateBusinessPoints()
				}
			},
			selectedPointId() {
				this.updateBusinessPoints()
			}
		},
		data() {
			return {
				data: [],
				myChart: '',
				mapLevae: 1,
				serData: null
			}
		},
		mounted() {
			this.getMapData()
		},
		methods: {
			buildBusinessPointSeries() {
				return {
					id: 'business-points',
					name: 'businessPoints',
					type: 'effectScatter',
					coordinateSystem: 'geo',
					geoIndex: 0,
					showEffectOn: 'render',
					rippleEffect: {
						period: 2,
						scale: 4,
						brushType: 'stroke'
					},
					symbol: 'circle',
					symbolSize: (value) => value[2].id === this.selectedPointId ? 18 : 13,
					itemStyle: {
						color: '#F7FF57',
						shadowBlur: 14,
						shadowColor: '#F7FF57'
					},
					label: {
						show: true,
						position: 'top',
						formatter: '{b}',
						color: '#D8F1FF',
						fontSize: 12,
						backgroundColor: 'rgba(5, 35, 85, .82)',
						borderColor: 'rgba(68, 193, 239, .45)',
						borderWidth: 1,
						padding: [3, 8]
					},
					zlevel: 100,
					data: this.businessPoints.map(item => ({
						name: item.name,
						value: [item.longitude, item.latitude, item]
					}))
				}
			},
			updateBusinessPoints() {
				if (!this.myChart) return
				this.myChart.setOption({
					series: [this.buildBusinessPointSeries()]
				})
			},
			getMapData(map) {
				let serData = []
				if (this.mapLevae == 1) {
					let cityList = [{
							"cityName": "福州",
							"longitude": 119.629485,
							"latitude": 26.204654
						}, {
							"cityName": "南京",
							"longitude": 118.796826,
							"latitude": 32.060255
						}, {
							"cityName": "四川省",
							"longitude": 104.065735,
							"latitude": 30.572017
						}, {
							"cityName": "武汉",
							"longitude": 114.305267,
							"latitude": 30.59306
						}, {
							"cityName": "安徽",
							"longitude": 117.286404,
							"latitude": 31.820575
						}, {
							"cityName": "北京",
							"longitude": 116.405285,
							"latitude": 39.904989
						},
						// {
						// 	"cityName": "广安",
						// 	"longitude": 106.63336,
						// 	"latitude": 30.45639
						// }, 
						// {
						// 	"cityName": "遂宁",
						// 	"longitude": 105.59774,
						// 	"latitude": 30.53799
						// }, 
						// {
						// 	"cityName": "青岛",
						// 	"longitude": 120.399414,
						// 	"latitude": 36.096972
						// }, 
						{
							"cityName": "海南",
							"longitude": 110.351074,
							"latitude": 20.031924
						},
						// {
						// 	"cityName": "山东金乡县",
						// 	"longitude": 116.311661,
						// 	"latitude": 34.92486
						// }, 
						// {
						// 	"cityName": "城口",
						// 	"longitude": 108.66502,
						// 	"latitude": 31.89262
						// }, 
						{
							"cityName": "郑州",
							"longitude": 113.665366,
							"latitude": 34.757975
						},
						// {
						// 	"cityName": "石柱",
						// 	"longitude": 108.23396,
						// 	"latitude": 29.99904
						// }, 
						// {
						// 	"cityName": "甘肃陇南",
						// 	"longitude": 104.92936,
						// 	"latitude": 33.38864
						// }, 
						// {
						// 	"cityName": "德阳",
						// 	"longitude": 104.39811,
						// 	"latitude": 31.12794
						// }, 
						// {
						// 	"cityName": "奉节",
						// 	"longitude": 109.46528,
						// 	"latitude": 31.02282
						// }, 
						{
							"cityName": "大理",
							"longitude": 100.22706,
							"latitude": 25.59066
						}, {
							"cityName": "南宁",
							"longitude": 108.373418,
							"latitude": 22.817504
						}, {
							"cityName": "山东",
							"longitude": 117.120089,
							"latitude": 36.651112
						},
						// {
						// 	"cityName": "重庆市武隆区",
						// 	"longitude": 107.75398,
						// 	"latitude": 29.32556
						// }, {
						// 	"cityName": "彭水县",
						// 	"longitude": 108.17238,
						// 	"latitude": 29.29408
						// },
						// {
						// 	"cityName": "四川绵阳市梓潼县",
						// 	"longitude": 105.16612,
						// 	"latitude": 31.63361
						// }, 
						// {
						// 	"cityName": "云南会泽县",
						// 	"longitude": 103.29838,
						// 	"latitude": 26.41456
						// }, {
						// 	"cityName": "怒江",
						// 	"longitude": 98.85681,
						// 	"latitude": 25.85094
						// }, 
						// {
						// 	"cityName": "甘肃武都",
						// 	"longitude": 104.92622,
						// 	"latitude": 33.20802
						// }, 
						// {
						// 	"cityName": "连云港",
						// 	"longitude": 119.16437,
						// 	"latitude": 34.59936
						// }, {
						// 	"cityName": "苏州",
						// 	"longitude": 120.61956,
						// 	"latitude": 31.31894
						// }, 
						{
							"cityName": "张掖",
							"longitude": 100.4552,
							"latitude": 38.93216
						},
						{
							"cityName": "库布齐农光互补基地",
							"longitude": 108.736011,
							"latitude": 39.833243
						},
						// {
						// 	"cityName": "綦江",
						// 	"longitude": 106.651362,
						// 	"latitude": 29.028067
						// }, {
						// 	"cityName": "大渡口",
						// 	"longitude": 106.482332,
						// 	"latitude": 29.484506
						// }, {
						// 	"cityName": "渝北",
						// 	"longitude": 106.511389,
						// 	"latitude": 29.607514
						// }, {
						// 	"cityName": "渝中",
						// 	"longitude": 106.55,
						// 	"latitude": 29.55
						// }, 
						// {
						// 	"cityName": "重庆市",
						// 	"longitude": 107.39583,
						// 	"latitude": 29.70194
						// },
						// {
						// 	"cityName": "彭水",
						// 	"longitude": 108.17238,
						// 	"latitude": 29.29408
						// }, {
						// 	"cityName": "长寿",
						// 	"longitude": 107.081283,
						// 	"latitude": 29.857996
						// },
					]
					serData.push({
						name: '重庆市',
						type: 'effectScatter',
						coordinateSystem: 'geo',
						effectType: 'ripple',
						showEffectOn: 'render',
						// 散点样式
						rippleEffect: {
							period: 1,
							scale: 2,
							brushType: 'fill'
						},
						// 散点大小 自定义散点图片
						symbol: `image://https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hotpot/brain/af6d44be8c331440b931aa0b74d417b.png`,
						symbolSize: [30, 30],
						hoverAnimation: true,
						// 标志的样式
						itemStyle: {
							normal: {
								color: 'red',
								shadowBlur: 10,
								shadowColor: '#333'
							}
						},
						label: {
							show: false,
							formatter: function(param) {
								return `{b| ${param.name}} 
								`
							},
							textStyle: {
								align: 'left'
							},
							position: 'top',
							distance: -1,
							backgroundColor: {
								image: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hotpot/brain/%E5%9B%BE%E4%BE%8B/Frame%402x.png',
							},
							width: 210,
							overflow: 'break',
							rich: {
								f: {
									color: '#fff',
									fontSize: 12,
									padding: [0, 0, 15, 0],
								},
								c: {
									color: '#FFC300',
									fontSize: 12,
									padding: [0, 0, 15, -10]
								},
								b: {
									color: "#fff",
									fontSize: 16,
									fontWeight: 900,
									padding: 15,
								},
							},
							emphasis: {
								show: true // 鼠标悬浮时显示标签
							}
						},
						zlevel: 99,
						data: [{
							name: '重庆市',
							value: [107.39583, 30.00194]
						}]
					})
					for (var i = 0; i < cityList.length; i++) {
						serData.push({
							name: cityList[i].cityName,
							type: 'effectScatter',
							coordinateSystem: 'geo',
							effectType: 'ripple',
							showEffectOn: 'render',
							// 散点样式
							rippleEffect: {
								period: 1,
								scale: 2,
								brushType: 'fill'
							},
							// 散点大小 自定义散点图片
							symbol: `image://https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hotpot/brain/%E5%9B%BE%E4%BE%8B/%E4%BE%9B%E5%BA%94%E5%95%86.png`,
							symbolSize: [30, 30],
							hoverAnimation: true,
							// 标志的样式
							itemStyle: {
								normal: {
									color: 'red',
									shadowBlur: 10,
									shadowColor: '#333'
								}
							},
							label: {
								show: false,
								formatter: function(param) {
									return `{b| ${param.name}} 
								`
								},
								textStyle: {
									align: 'left'
								},
								position: 'top',
								distance: -1,
								backgroundColor: {
									image: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hotpot/brain/%E5%9B%BE%E4%BE%8B/Frame%402x.png',
								},
								width: 210,
								overflow: 'break',
								rich: {
									f: {
										color: '#fff',
										fontSize: 12,
										padding: [0, 0, 15, 0],
									},
									c: {
										color: '#FFC300',
										fontSize: 12,
										padding: [0, 0, 15, -10]
									},
									b: {
										color: "#fff",
										fontSize: 16,
										fontWeight: 900,
										padding: 15,
									},
								},
								emphasis: {
									show: true // 鼠标悬浮时显示标签
								}
							},
							zlevel: 99,
							data: [{
								name: cityList[i].cityName,
								value: [cityList[i].longitude, cityList[i].latitude]
							}]
						})
					}
					this.serData = serData
					this.init(serData, 'china');
				} else {
					// this.$request('/center/home/middleMap').then(res => {
					let gysData = [{
							"city": "重庆市",
							"list": [{
								"shopName": "武隆苕粉",
								"chargePersonName": "王晓路",
								"shopAddress": "重庆市武隆区白马镇园区东路73号武隆苕粉科创园",
								"roles": "供应商、采购商",
								"longitude": "107.532211",
								"latitude": "29.381037",
								"shopType": "供应商"
							}, {
								"shopName": "凯鸿食品",
								"chargePersonName": "苟志强",
								"shopAddress": "重庆市合川区龙市镇龙腾大道99号",
								"roles": "供应商、采购商",
								"longitude": "106.466096",
								"latitude": "30.221737",
								"shopType": "供应商"
							}, {
								"shopName": "钰鑫",
								"chargePersonName": "尹顺新",
								"shopAddress": "重庆市大渡口区春晖路街道松青路1048号翠云街18号",
								"roles": "供应商",
								"longitude": "106.485373",
								"latitude": "29.478118",
								"shopType": "采购商"
							}, {
								"shopName": "晶丝苕粉",
								"chargePersonName": "王秀文",
								"shopAddress": "重庆市彭水苗族土家族自治县重庆烟爆集团(彭水专营店)二级路口长城皮卡",
								"roles": "供应商、采购商",
								"longitude": "108.165538",
								"latitude": "29.293902",
								"shopType": "供应商"
							}]
						},
						{
							"city": "福建省",
							"list": [{
								"shopName": "福州百洋",
								"chargePersonName": "许正华",
								"shopAddress": "福建省福州市晋安区东二环泰禾8座626",
								"roles": "供应商",
								"longitude": "119.750000",
								"latitude": "26.300000",
								"shopType": "供应商"
							}]
						},
						{
							"city": "甘肃省",
							"list": [{
								"shopName": "张掖杏皮茶",
								"chargePersonName": "朱珠",
								"shopAddress": "甘肃省张掖市甘州区张掖经济技术开发区生态科技产业园科技路3号",
								"roles": "供应商",
								"longitude": "100.448694",
								"latitude": "38.940709",
								"shopType": "供应商"
							}, {
								"shopName": "张掖辣椒",
								"chargePersonName": "巴志强",
								"shopAddress": "甘肃省张掖市甘州区张掖经济技术开发区辣椒基地",
								"roles": "供应商",
								"longitude": "100.200000",
								"latitude": "39.100000",
								"shopType": "供应商"
							}, {
								"shopName": "武都花椒",
								"chargePersonName": "高志东",
								"shopAddress": "渝中区民族路188号",
								"roles": "供应商",
								"longitude": "101.22",
								"latitude": "38.54",
								"shopType": "供应商"
							}]
						}, {
							"city": "四川省",
							"list": [{
								"shopName": "梓潼粉",
								"chargePersonName": "胡琪",
								"shopAddress": "四川省绵阳市梓潼县经开区文昌大道南段970号",
								"roles": "供应商",
								"longitude": "105.17",
								"latitude": "31.64",
								"shopType": "供应商"
							}]
						}
					]
					let bgList = {
						'供应商': 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hotpot/brain/%E5%9B%BE%E4%BE%8B/%E4%BE%9B%E5%BA%94%E5%95%86.png',
						'采购商': 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hotpot/brain/%E5%9B%BE%E4%BE%8B/%E9%87%87%E8%B4%AD%E5%95%86.png',
						'精深加工厂': 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hotpot/brain/%E5%9B%BE%E4%BE%8B/%E7%B2%BE%E6%B7%B1%E5%8A%A0%E5%B7%A5.png',
						'前置仓': 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hotpot/brain/%E5%9B%BE%E4%BE%8B/%E5%89%8D%E7%BD%AE%E4%BB%93.png',
						'蔬菜基地': 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hotpot/brain/%E5%9B%BE%E4%BE%8B/%E8%94%AC%E8%8F%9C%E5%9F%BA%E5%9C%B0.png',
					}
					if (map == '500000') {
						this.data = gysData[0].list
						serData.push({
							name: `夔州肉兔智慧养殖`,
							type: 'effectScatter',
							coordinateSystem: 'geo',
							effectType: 'ripple',
							showEffectOn: 'render',
							// 散点样式
							rippleEffect: {
								period: 1,
								scale: 2,
								brushType: 'fill'
							},
							// 散点大小 自定义散点图片
							symbol: `image://https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hotpot/brain/%E5%9B%BE%E4%BE%8B/%E7%B2%BE%E6%B7%B1%E5%8A%A0%E5%B7%A5.png`,
							symbolSize: [35, 35],
							hoverAnimation: true,
							// 标志的样式
							itemStyle: {
								normal: {
									color: 'red',
									shadowBlur: 10,
									shadowColor: '#333'
								}
							},
							label: {
								show: false,
								formatter: function(param) {
									return `{b| 夔州肉兔智慧养殖} 
											{c| 产业规模：} {f| 700万只} 
											{c| 家庭农场：} {f| 183个} 
											{c| 出栏肉兔：} {f| 469万只} 
											{c| 兔肉产值：} {f| 3.35亿}`
								},
								textStyle: {
									align: 'left'
								},
								position: 'top',
								distance: -1,
								backgroundColor: {
									image: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hotpot/brain/%E5%9B%BE%E4%BE%8B/Frame%402x.png',
								},
								width: 410,
								overflow: 'break',
								rich: {
									f: {
										color: '#fff',
										fontSize: 12,
										padding: [0, 0, 15, 0],
									},
									c: {
										color: '#FFC300',
										fontSize: 12,
										padding: [0, 0, 15, -10]
									},
									b: {
										color: "#fff",
										fontSize: 16,
										fontWeight: 900,
										padding: 15,
									},
								},
								emphasis: {
									show: true // 鼠标悬浮时显示标签
								}
							},
							zlevel: 99,
							data: [{
								name: '夔州肉兔智慧养殖',
								value: [109.412211, 30.804037]
							}]
						})


					} else if (map == '620000') {
						this.data = gysData[2].list
					} else if (map == '350000') {
						this.data = gysData[1].list
					} else if (map == '510000') {
						this.data = gysData[3].list
					}
					// 散点图配置
					this.data.forEach((item) => {
						console.log(item.shopType);
						serData.push({
							name: `${item.shopName}`,
							type: 'effectScatter',
							coordinateSystem: 'geo',
							effectType: 'ripple',
							showEffectOn: 'render',
							// 散点样式
							rippleEffect: {
								period: 1,
								scale: 2,
								brushType: 'fill'
							},
							// 散点大小 自定义散点图片
							symbol: `image://${bgList[item.shopType]}`,
							symbolSize: [35, 35],
							hoverAnimation: true,
							// 标志的样式
							itemStyle: {
								normal: {
									color: 'red',
									shadowBlur: 10,
									shadowColor: '#333'
								}
							},
							label: {
								show: false,
								formatter: function(param) {
									return `{b| ${item.shopName}} 
											{c| 店铺名称：} {f| ${item.shopName}} 
											{c| 负责人：} {f| ${item.chargePersonName}} 
											{c| 店铺类型：} {f| ${item.shopType}} 
											{c| 店铺地址：} {f| ${item.shopAddress}}`
								},
								textStyle: {
									align: 'left'
								},
								position: 'top',
								distance: -1,
								backgroundColor: {
									image: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hotpot/brain/%E5%9B%BE%E4%BE%8B/Frame%402x.png',
								},
								width: 410,
								overflow: 'break',
								rich: {
									f: {
										color: '#fff',
										fontSize: 12,
										padding: [0, 0, 15, 0],
									},
									c: {
										color: '#FFC300',
										fontSize: 12,
										padding: [0, 0, 15, -10]
									},
									b: {
										color: "#fff",
										fontSize: 16,
										fontWeight: 900,
										padding: 15,
									},
								},
								emphasis: {
									show: true // 鼠标悬浮时显示标签
								}
							},
							zlevel: 99,
							data: [{
								name: item.shopName,
								value: [Number(item.longitude), Number(item.latitude)]
							}]
						})
					})
					this.serData = serData
					console.log(this.serData);
					this.init(serData, map);
				}

			},
			showType(e) {
				let da = []
				for (var i = 0; i < this.data.length; i++) {
					if (this.data[i].showType == e) {
						da.push({
							show: false
						})
					} else {
						da.push({
							show: true
						})
					}
				}
				this.myChart.setOption({
					series: da
				})
			},
			init(serData, map) {
				if (this.myChart) {
					this.myChart.off();
					this.myChart.clear()

				}
				let that = this
				this.myChart = echarts.init(document.getElementById("myEcharts4"), "purple-passion");
				//随着屏幕大小调节图表
				window.addEventListener("resize", () => {
					this.myChart.resize();
				});
				var img2 =
					'image://data:image/png;base64,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';
				var mapName = 'chongqing';

				var data = [{
						name: '北京',
						value: 5
					},
					{
						name: '天津',
						value: 14
					},
					{
						name: '河北',
						value: 157
					},
					{
						name: '山西',
						value: 110
					},
					{
						name: '内蒙古',
						value: 40
					},
					{
						name: '辽宁',
						value: 40
					},
					{
						name: '吉林',
						value: 40
					},
					{
						name: '黑龙江',
						value: 60
					},
					{
						name: '上海',
						value: 10
					},
					{
						name: '江苏',
						value: 60
					},
					{
						name: '浙江',
						value: 50
					},
					{
						name: '安徽',
						value: 151
					},
					{
						name: '福建',
						value: 60
					},
					{
						name: '江西',
						value: 74
					},
					{
						name: '山东',
						value: 200
					},
					{
						name: '河南',
						value: 100
					},
					{
						name: '湖北',
						value: 40
					},
					{
						name: '湖南',
						value: 50
					},
					{
						name: '重庆',
						value: 40
					},
					{
						name: '四川',
						value: 120
					},
					{
						name: '贵州',
						value: 135
					},
					{
						name: '云南',
						value: 90
					},
					{
						name: '西藏',
						value: 25
					},
					{
						name: '陕西',
						value: 100
					},
					{
						name: '甘肃',
						value: 60
					},
					{
						name: '青海',
						value: 20
					},
					{
						name: '宁夏',
						value: 110
					},
					{
						name: '新疆',
						value: 32
					},
					{
						name: '广东',
						value: 10
					},
					{
						name: '广西',
						value: 100
					},
					{
						name: '海南',
						value: 40
					},
				];
				fetch(`https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hotpot/brain/mapJss/${map}.geoJson`).then(
						response => response.json())
					.then(data => {
						echarts.registerMap('chongqing', data);


						var toolTipData = [{
								name: '湖南',
								value: 5,
								areas: ["长沙", "株洲", "益阳"]
							},
							{
								name: '安徽',
								value: 3,
								areas: ["合肥", "芜湖"]
							},
							{
								name: '山东',
								value: 80,
								areas: ["济南", "青岛", "淄博", "烟台", "威海", "临沂"]
							},
							{
								name: '四川',
								value: 35,
								areas: ["成都", "攀枝花", "乐山", "泸州"]
							},
							{
								name: '云南',
								value: 27,
								areas: ["昆明", "玉溪", "丽江", "普洱", "临沧"]
							},
							{
								name: '黑龙江',
								value: 13,
								areas: ["哈尔滨", "鹤岗", "黑河", "绥化", "大庆", "佳木斯"]
							},
							{
								name: '甘肃',
								value: 42,
								areas: ["兰州", "嘉峪关", "天水", "酒泉"]
							},
							{
								name: '西藏',
								value: 74,
								areas: []
							}
						];
						var geoCoordMap = {
							'黑龙江': [127.9688, 45.368],
							'内蒙古': [110.3467, 41.4899],
							"吉林": [125.8154, 44.2584],
							'北京市': [116.4551, 40.2539],
							"辽宁": [123.1238, 42.1216],
							"河北": [114.4995, 38.1006],
							"天津": [117.4219, 39.4189],
							"山西": [112.3352, 37.9413],
							"陕西": [109.1162, 34.2004],
							"甘肃": [103.5901, 36.3043],
							"宁夏": [106.3586, 38.1775],
							"青海": [101.4038, 36.8207],
							"新疆": [87.611053, 43.828171],
							"西藏": [91.117212, 29.646922],
							"四川": [103.9526, 30.7617],
							"重庆": [108.384366, 30.439702],
							"山东": [117.1582, 36.8701],
							"河南": [113.4668, 34.6234],
							"江苏": [118.8062, 31.9208],
							"安徽": [117.29, 32.0581],
							"湖北": [114.3896, 30.6628],
							"浙江": [119.5313, 29.8773],
							"福建": [119.4543, 25.9222],
							"江西": [116.0046, 28.6633],
							"湖南": [113.0823, 28.2568],
							"贵州": [106.6992, 26.7682],
							"云南": [102.9199, 25.4663],
							"广东": [113.12244, 23.009505],
							"广西": [108.479, 23.1152],
							"海南": [110.3893, 19.8516],
							"台湾": [120.702967, 24.123621],
							'上海': [121.4648, 31.2891]

						};

						/*获取地图数据*/
						this.myChart.showLoading();
						var mapFeatures = data.features;
						this.myChart.hideLoading();
						mapFeatures.forEach(function(v) {
							// 地区名称
							var name = v.properties.name;
							// 地区经纬度
							geoCoordMap[name] = v.properties.cp;
						});

						var convertData = function(data) {
							var res = [];
							for (var i = 0; i < data.length; i++) {
								var geoCoord = geoCoordMap[data[i].name];
								if (geoCoord) {
									res.push({
										name: data[i].name,
										value: geoCoord.concat(data[i].value),
									});
								}
							}
							return res;
						};
						// 柱状体的主干
						function lineData() {
							return toolTipData.map((item) => {
								return {
									coords: [geoCoordMap[item.name],
										[geoCoordMap[item.name][0], geoCoordMap[item.name][1] + 1.5]
									]
								}
							})
						}
						// 柱状体的顶部
						function scatterData() {
							return toolTipData.map((item) => {
								return [geoCoordMap[item.name][0], geoCoordMap[item.name][1] + 2, item]
							})
						}
						var option = {
							// backgroundColor: "#003366",
							title: {
								show: true,
								// text: "项目分布图",
								x: 'center',
								top: "10",
								textStyle: {
									color: "#fff",
									fontFamily: "等线",
									fontSize: 18,
								},
							},
							tooltip: {
								trigger: 'none',
								formatter: function(params) {
									if (typeof params.value[2] == 'undefined') {
										var toolTiphtml = '';
										for (var i = 0; i < toolTipData.length; i++) {
											if (params.name == toolTipData[i].name) {
												toolTiphtml += toolTipData[i].name + "：" + toolTipData[i]
													.value;
											}
										}
										return toolTiphtml;
									} else {
										var toolTiphtml = '';
										for (var i = 0; i < toolTipData.length; i++) {
											if (params.name == toolTipData[i].name) {
												toolTiphtml += toolTipData[i].name + "：" + toolTipData[i]
													.value;
											}
										}
										return toolTiphtml;
									}
								},
								backgroundColor: "#fff",
								borderColor: "#333",
								padding: [5, 10],
								textStyle: {
									color: "#333",
									fontSize: "16"
								}
							},
							geo: [{
								layoutCenter: ['47%', '53%'], //位置
								layoutSize: this.scanal + '%', //大小
								show: true,
								map: mapName,
								roam: true,
								zoom: 0.85,
								aspectScale: 1,
								label: {
									normal: {
										show: true,
										textStyle: {
											color: '#fff'
										}
									},
									emphasis: {
										show: true,
										textStyle: {
											color: '#fff'
										}
									}
								},
								itemStyle: {
									normal: {
										areaColor: {
											type: "linear",
											x: 1200,
											y: 0,
											x2: 0,
											y2: 0,
											colorStops: [{
												offset: 0,
												color: "rgba(46, 119, 203, 0.9)", // 0% 处的颜色
											}, {
												offset: 1,
												color: "rgba(58,149,253,0.95)", // 50% 处的颜色
											}, ],
											global: true, // 缺省为 false
										},
										borderColor: "#c0f3fb",
										borderWidth: 1,
										shadowColor: "#beebff",
										shadowOffsetY: 10,
										shadowBlur: 10,
									},
									emphasis: {
										areaColor: "rgba(0,254,233,0.6)",
										// borderWidth: 0
									}
								}
							}, {
								show: false,
								type: "map",
								map: mapName,
								zlevel: -1,
								aspectScale: 1,
								zoom: 0.55,
								layoutCenter: ["50%", "51%"],
								layoutSize: "180%",
								roam: false,
								silent: true,
								itemStyle: {
									normal: {
										borderWidth: 1,
										// borderColor:"rgba(17, 149, 216,0.6)",
										borderColor: "rgba(58,149,253,0.8)",
										shadowColor: "rgba(172, 122, 255,0.5)",
										shadowOffsetY: 5,
										shadowBlur: 15,
										areaColor: "rgba(5,21,35,0.1)",
									},
								},
							}, {
								show: false,
								type: "map",
								map: mapName,
								zlevel: -2,
								aspectScale: 1,
								zoom: 0.55,
								layoutCenter: ["50%", "52%"],
								layoutSize: "180%",
								roam: false,
								silent: true,
								itemStyle: {
									normal: {
										borderWidth: 1,
										// borderColor: "rgba(57, 132, 188,0.4)",
										borderColor: "rgba(58,149,253,0.6)",
										shadowColor: "rgba(65, 214, 255,1)",
										shadowOffsetY: 5,
										shadowBlur: 15,
										areaColor: "transpercent",
									},
								},
							}, {
								show: false,
								type: "map",
								map: mapName,
								zlevel: -3,
								aspectScale: 1,
								zoom: 0.55,
								layoutCenter: ["50%", "53%"],
								layoutSize: "180%",
								roam: false,
								silent: true,
								itemStyle: {
									normal: {
										borderWidth: 1,
										// borderColor: "rgba(11, 43, 97,0.8)",
										borderColor: "rgba(58,149,253,0.4)",
										shadowColor: "rgba(58,149,253,1)",
										shadowOffsetY: 15,
										shadowBlur: 10,
										areaColor: "transpercent",
									},
								},
							}, {
								show: false,
								type: "map",
								map: mapName,
								zlevel: -4,
								aspectScale: 1,
								zoom: 0.55,
								layoutCenter: ["50%", "54%"],
								layoutSize: "180%",
								roam: false,
								silent: true,
								itemStyle: {
									normal: {
										borderWidth: 5,
										// borderColor: "rgba(11, 43, 97,0.8)",
										borderColor: "rgba(5,9,57,0.8)",
										shadowColor: "rgba(29, 111, 165,0.8)",
										shadowOffsetY: 15,
										shadowBlur: 10,
										areaColor: "rgba(5,21,35,0.1)",
									},
								},
							}, ],
							series: [
								...serData,
								{
									type: 'map',
									map: mapName,
									geoIndex: 0,
									aspectScale: 1, //长宽比
									zoom: 0.55,
									showLegendSymbol: true,
									roam: true,
									label: {
										normal: {
											show: true,
											textStyle: {
												color: "#fff",
												fontSize: "120%"
											},
										},
										emphasis: {
											// show: false,
										},
									},
									itemStyle: {
										normal: {
											areaColor: {
												type: "linear",
												x: 1200,
												y: 0,
												x2: 0,
												y2: 0,
												colorStops: [{
													offset: 0,
													color: "rgba(3,27,78,0.75)", // 0% 处的颜色
												}, {
													offset: 1,
													color: "rgba(58,149,253,0.75)", // 50% 处的颜色
												}, ],
												global: true, // 缺省为 false
											},
											borderColor: "#fff",
											borderWidth: 0.2,
										},
									},
									layoutCenter: ["50%", "50%"],
									layoutSize: "180%",
									animation: false,
									markPoint: {
										symbol: "none"
									},
									// data: data,
								},
								//柱状体的主干
								{
									type: 'lines',
									zlevel: 5,
									effect: {
										show: false,
										symbolSize: 5 // 图标大小
									},
									lineStyle: {
										width: 6, // 尾迹线条宽度
										color: 'rgba(249, 105, 13, .6)',
										opacity: 1, // 尾迹线条透明度
										curveness: 0 // 尾迹线条曲直度
									},
									label: {
										show: 0,
										position: 'end',
										formatter: '245'
									},
									silent: true,
									// data: lineData()
								},
								// 柱状体的顶部
								{
									type: 'scatter',
									coordinateSystem: 'geo',
									geoIndex: 0,
									zlevel: 5,
									label: {
										normal: {
											show: true,
											formatter: function(params) {
												var name = params.data[2].name
												var value = params.data[2].value
												var text = `{tline|${name}} : {fline|${value}}个`
												// var text = `{tline|项目个数} : {fline|${value}}`
												return text;
											},
											color: '#fff',
											rich: {
												fline: {
													// padding: [0, 25],
													color: '#fff',
													fontSize: 14,
													fontWeight: 600
												},
												tline: {
													// padding: [0, 27],
													color: '#ABF8FF',
													fontSize: 12,
												},
											}
										},
										emphasis: {
											show: true
										}
									},
									itemStyle: {
										color: '#00FFF6',
										opacity: 1
									},
									symbol: img2,
									symbolSize: [110, 60],
									symbolOffset: [0, -20],
									z: 999,
									// data: scatterData(),
								},
								{
									name: 'Top 5',
									type: 'effectScatter',
									coordinateSystem: 'geo',
									// data: convertData(toolTipData),
									showEffectOn: 'render',
									itemStyle: {
										normal: {
											color: '#00FFFF',
										}
									},
									rippleEffect: {
										scale: 5,
										brushType: 'stroke',
									},
									label: {
										normal: {
											formatter: '{b}',
											position: 'bottom',
											show: false,
											color: "#fff",
											distance: 10,
										},
									},
									symbol: 'circle',
									symbolSize: [20, 10],
									itemStyle: {
										normal: {
											color: '#16ffff',
											shadowBlur: 10,
											shadowColor: '#16ffff',
										},
										opacity: 1
									},
									zlevel: 4,
								},
								this.buildBusinessPointSeries(),
							],
						};
						this.myChart.setOption(option);
						this.myChart.on('click', (e) => {
							if (e.seriesName === 'businessPoints' && e.data && e.data.value && e.data.value[2]) {
								this.$emit('business-point-click', e.data.value[2])
								return
							}
							if (e.name == '重庆市') {
								this.mapLevae = 2
								this.getMapData('500000')
							} else if (e.name == '甘肃省') {
								this.mapLevae = 2
								this.getMapData('620000')
							} else if (e.name == '福建省') {
								this.mapLevae = 2
								this.getMapData('350000')
							} else if (e.name == '四川省') {
								this.mapLevae = 2
								this.getMapData('510000')
							}
							if (sessionStorage.getItem('type') == 'scjgj') {
								if (e.name == '夔州肉兔智慧养殖') {
									this.$kzrtRequest.post('/qg-center/center/getAccessToken').then(res=>{
										window.open('http://kzrtdn.18yimu.com/index/#/login?accessToken='+res.data.accessToken)
									})
								}
							} else {
								if (e.name == '夔州肉兔智慧养殖') {
									window.open('http://kzrtdn.18yimu.com/new/#/')
								} else if (e.name == '张掖') {
									window.open('http://sp.18yimu.com/#/')
								} else if (e.name == '库布齐农光互补基地') {
									window.open('https://nm.18yimu.com/#/')
								}
							}

						})
					})

			}
		}
	}
</script>

<style scoped>
	.back {
		background-image: url('https://qgst.obs.cn-southwest-2.myhuaweicloud.com/rabbit/pc/industrial/back.png');
		width: 200px;
		height: 50px;
		background-size: 100% 100%;
		color: #fff;
		position: absolute;
		left: 25%;
		top: 23%;
		line-height: 50px;
		text-align: center;
		font-size: 18px;
		z-index: 9;
		cursor: pointer;
	}

	.tuli-title {
		font-weight: bold;
		font-size: 14px;
		color: #FFFFFF;
	}

	.tuli {
		position: absolute;
		right: 25%;
		bottom: 10%;
	}

	.sycw {
		font-size: 72rpx;
		font-family: DingTalk JinBuTi, DingTalk JinBuTi;
		font-weight: 900;
		color: #FFFFFF;
		text-shadow: 0px 8rpx 20rpx rgba(0, 0, 0, 0.8);
		-webkit-background-clip: text;
		-webkit-text-fill-color: #ffedf6;
	}

	.title {
		font-size: 24rpx;
		font-family: Source Han Sans, Source Han Sans;
		font-weight: 400;
		color: #dbecff;
		line-height: 40px;
		margin-left: 20rpx;
	}

	.bg {
		width: 30rpx;
		height: 30rpx;

	}
</style>
